module.exports = __webpack_public_path__ + "img/list_slide_01.308f1f27.jpg";